exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".send-invoice-block button {\n  margin-bottom: 5rem;\n  max-width: 49rem;\n}\n\n.send-invoice-block button:last-child {\n  margin-bottom: 0;\n}\n\n.send-invoice-block__kivra-reason {\n  display: block;\n  text-align: center;\n  color: #FF0049;\n}\n\n", ""]);

// exports
